import styled from "@emotion/styled";
import {ReactComponent as svgHead} from "../../../../images/800CallLogs/Resources for Call Logs/MenWithHeadphone.svg"

export const MenWithHeadphoneSvg = styled(svgHead)`
    margin-top: 30px;
    width: 88.28px;
    height: 96.52px;
    margin-bottom: 0px;
`;